export class IdentityHubComponent {
  container;

  constructor() {
    this.container = document.querySelector('body.page-template-identity_hub_archive');
  }

  initialize() {
    if (!this.container) {
      return;
    }

    this.addEventListeners();
  }

  addEventListeners() {
    const modalOpenButton = document.querySelector('.js-open-subscribe-modal');
    if (modalOpenButton) {
      modalOpenButton.addEventListener('click', (e) => this.modalOpenButtonClickHandler(e));
    }
  }

  async showModal() {
    const container = document.querySelector('.js-subscribe-modal-wrapper');
    if (!container) {
      return;
    }

    const form = container.querySelector('.hbspt-form');
    if (!form) {
      return;
    }

    const title = container.querySelector('.js-title');
    const description = container.querySelector('.js-description');

    let html = '';
    if (title) {
      html += title.outerHTML;
    }

    html += form.outerHTML;

    if (description) {
      html += description.outerHTML;
    }
    
    const wrapper = document.createElement('div');
    wrapper.classList.add('subscribe-modal-wrapper');
    wrapper.innerHTML = html;

    try {
      const {Fancybox} = await import('@fancyapps/ui' /*webpackChunkName: "fancy" */);
      new Fancybox([
        {
          src: wrapper,
          type: 'html'
        }
      ]);
    } catch (error) {
      console.error('Error importing FancyBox:', error);
    }
  }

  modalOpenButtonClickHandler(e) {
    this.showModal();
  }
}